import apiFetch from '@wordpress/api-fetch';

jQuery(document).ready(function ($) {
  $('.js-header-submenu').prepend($('.js-submenu').clone().removeClass('m-main__sub-menu').addClass('header-submenu__menu'));

  $('.js-menu-icon').click(function (e) {
    if ($(window).width >= 1200) {
      return;
    }
    e.preventDefault();
    $(this).parents('.js-menu-main-item').toggleClass('open');
    return false;
  });

  $('.js-scroll-to').click(function (e) {
    e.preventDefault();

    let anchor = $($(this).attr('href'));

    if (!anchor.length) {
      return false;
    }

    $('html,body').animate({scrollTop: anchor.offset().top - 100}, 1000);
  });

  $('.js-show-popular-posts').click(function (e) {
    e.preventDefault();
    $(this).parent().hide();
    $('.js-popular-posts').removeClass('hidden');
  });

  $('.js-load-more-similar-posts').click(function (e) {
    e.preventDefault();
    let button = $(this);
    let buttonText = button.find('.js-similar-posts-button-text');
    let list = $('.js-similar-posts-list');
    button.prop('disabled', true);
    buttonText.text('Načítám příspěvky...');

    let postId = parseInt(list.attr('data-post-id'));
    let page = (parseInt(list.attr('data-page')) + 1);
    let limit = parseInt(list.attr('data-limit'));

    apiFetch({
      path: pruvodce_podnikanim.api_path + '/posts/?' + new URLSearchParams({
        post_id: postId,
        page: page,
        limit: limit,
      }),
      method: 'GET',
    })
      .then((response) => {
        list.append(response.html);
        list.attr('data-page', page);

        if ('' === response.button_label) {
          button.remove();
        } else {
          button.prop('disabled', false);
          buttonText.text(response.button_label);
        }
      });
  });

  $('.js-search-documents').keyup(function () {
    let search = $(this).val();
    $('.js-documents-section').show();
    if (search === '') {
      $('.js-document-item').show();
    } else {
      $('.js-document-title').each(function () {
        let title = $(this);
        if (title.text().toLowerCase().indexOf(search.toLowerCase()) !== -1) {
          title.parents('.js-document-item').show();
        } else {
          title.parents('.js-document-item').hide();
        }
      });

      $('.js-documents-section').each(function () {
        let section = $(this);
        console.log(section.find('.js-document-item:visible').length);
        if (section.find('.js-document-item:visible').length === 0) {
          section.hide();
        } else {
          section.show();
        }
      });
    }
  });
});